import { render, staticRenderFns } from "./QualitaMenu.vue?vue&type=template&id=5d51735a&scoped=true&"
import script from "./QualitaMenu.vue?vue&type=script&lang=js&"
export * from "./QualitaMenu.vue?vue&type=script&lang=js&"
import style0 from "./QualitaMenu.vue?vue&type=style&index=0&id=5d51735a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d51735a",
  null
  
)

export default component.exports